import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/image/empty.webp'
import _imports_1 from '@/assets/image/empty.jpg'


const _hoisted_1 = _imports_0
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "card__up" }
const _hoisted_4 = { class: "card__up-case" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["srcset"]
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 0,
  class: "card__up-case-info"
}
const _hoisted_10 = { class: "card__down" }
const _hoisted_11 = { class: "card__down-prices" }
const _hoisted_12 = {
  key: 0,
  class: "card__down-price-old"
}
const _hoisted_13 = { class: "card__down-price-new" }
const _hoisted_14 = {
  key: 0,
  class: "card__down-price-tag"
}
const _hoisted_15 = { class: "animation-btn" }

import { onMounted, onUnmounted, PropType, ref } from "vue";
  import ChangeBasket from "./ChangeBasket.vue";
  import SwipeModal from "./SwipeModal.vue";
  import CardDetail from "./CardDetail.vue";
  import { priceFormat } from "@/helpers/priceFormat";
  import { eventBus } from "@/helpers/eventBus";
  import { IProduct } from "@/models/models";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'Card',
  props: {
    data: {
      type: Object as PropType<IProduct> | null,
      required: true,
    },
  },
  setup(__props) {

  const props = __props;
  
  const bottomSheetRef = ref<InstanceType<typeof SwipeModal>>();

  const isVisible = ref(false);

  const onOpenDetail = () => {
    isVisible.value = true;
    setTimeout(() => {
      bottomSheetRef.value?.open();
    }, 200);
  };

  const onCloseDetail = () => {
    isVisible.value = false;
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: "card__up-case-img",
            onClick: onOpenDetail
          }, [
            (__props.data.images.length != 0)
              ? (_openBlock(), _createElementBlock("picture", _hoisted_5, [
                  _createElementVNode("source", {
                    srcset: 'https://akshop.a-dev.xyz' + __props.data.images[0]
                  }, null, 8, _hoisted_6),
                  _createElementVNode("img", {
                    src: 'https://akshop.a-dev.xyz' + __props.data.images[0],
                    alt: __props.data.name,
                    loading: "eager"
                  }, null, 8, _hoisted_7)
                ]))
              : (_openBlock(), _createElementBlock("picture", _hoisted_8, _cache[0] || (_cache[0] = [
                  _createElementVNode("source", { srcset: _hoisted_1 }, null, -1),
                  _createElementVNode("img", {
                    src: _imports_1,
                    alt: "Нет фото",
                    loading: "eager"
                  }, null, -1)
                ])))
          ]),
          false
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _cache[1] || (_cache[1] = [
                _createElementVNode("div", { class: "card__up-case-info-value" }, "В наличии: 18 шт", -1),
                _createElementVNode("div", { class: "card__up-case-info-text" }, "399.99 ₽/кг", -1)
              ])))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "card__up-case-text",
            onClick: onOpenDetail
          }, _toDisplayString(__props.data.name), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          false
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, "109.90 ₽ /шт"))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_13, [
            _createTextVNode(_toDisplayString(_unref(priceFormat)(__props.data.basePrice)) + " ", 1),
            (__props.data.measure == 'кг' && false)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, " 1 кг "))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(ChangeBasket, { source: __props.data }, null, 8, ["source"])
        ])
      ])
    ]),
    (isVisible.value)
      ? (_openBlock(), _createBlock(SwipeModal, {
          key: 0,
          ref_key: "bottomSheetRef",
          ref: bottomSheetRef,
          onOnCloseDetail: onCloseDetail
        }, {
          default: _withCtx(() => [
            _createVNode(CardDetail, { data: __props.data }, null, 8, ["data"])
          ]),
          _: 1
        }, 512))
      : _createCommentVNode("", true)
  ], 64))
}
}

})